import type { MutationTree } from 'vuex'
import type { MapCoords, MapState, DeviceToMove, UpdateSettingsPayload, DeviceToView } from './types'
import { MAP_MUTATIONS } from './types'

interface IMapMutations extends MutationTree<MapState> {
  [MAP_MUTATIONS.SET_MOVING_PIN](state: MapState, deviceToMove: DeviceToMove | null): void
  [MAP_MUTATIONS.SET_LAST_ZOOM](state: MapState, zoom: number): void
  [MAP_MUTATIONS.SET_ZOOM](state: MapState, zoom: number): void
  [MAP_MUTATIONS.SET_CENTER](state: MapState, center: MapCoords): void
  [MAP_MUTATIONS.SET_MOVING_MODE](state: MapState, movingMode: boolean): void
  [MAP_MUTATIONS.SET_DEVICE_VIEW_MODE](state: MapState, deviceViewMode: boolean): void
  [MAP_MUTATIONS.SET_DEVICE_TO_VIEW](state: MapState, deviceToView: DeviceToView): void
  [MAP_MUTATIONS.UPDATE_SETTINGS](state: MapState, data: UpdateSettingsPayload): void
  [MAP_MUTATIONS.UPDATE_LOCATION](state: MapState): void
}

const mutations: IMapMutations = {
  [MAP_MUTATIONS.SET_MOVING_PIN](state, deviceToMove) {
    state.deviceToMove = deviceToMove
  },
  [MAP_MUTATIONS.SET_LAST_ZOOM](state, zoom) {
    state.location.lastZoom = zoom
  },
  [MAP_MUTATIONS.SET_ZOOM](state, zoom) {
    state.location.zoom = zoom
  },
  [MAP_MUTATIONS.SET_CENTER](state, center) {
    state.location.center = center
  },
  [MAP_MUTATIONS.SET_MOVING_MODE](state, movingMode) {
    state.movingMode = movingMode
  },
  [MAP_MUTATIONS.SET_DEVICE_VIEW_MODE](state, deviceViewMode) {
    state.deviceViewMode = deviceViewMode
  },
  [MAP_MUTATIONS.SET_DEVICE_TO_VIEW](state, deviceToView) {
    state.deviceToView = deviceToView
  },
  [MAP_MUTATIONS.UPDATE_SETTINGS](state, data) {
    state.shownSettings = { ...state.shownSettings, ...data }
    localStorage.setItem('tsi.mapSettings', JSON.stringify(state.shownSettings))
  },
  [MAP_MUTATIONS.UPDATE_LOCATION](state) {
    localStorage.setItem('tsi.mapLocation', JSON.stringify(state.location))
  }
}

export default mutations
